export default __webpack_public_path__ + "static/indian2-wide-b78d1d705ba74844c41920065fc582c0.jpg";